import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { citationsApi } from './Citationsapi';
import { Empty } from '../ecourt/EcourtUi';
import { JudgmentRow, fmtTs } from './Citationui';

const COURT_LABEL = { supremecourt: 'Supreme Court', highcourts: 'High Courts', tribunals: 'Tribunals' };


export default function CitationRecent({ userId }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!userId) return undefined;
    let alive = true;
    citationsApi.history(userId, 40)
      .then((r) => { if (alive) setItems(r.items || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [userId]);

  if (items === null) return null;

  const searches = [];
  const seenQ = new Set();
  const docs = [];
  const seenT = new Set();
  items.forEach((it) => {
    if (it.action === 'search' && it.query_text) {
      const key = `${it.query_text.toLowerCase()}|${it.court || 'all'}`;
      if (!seenQ.has(key) && searches.length < 6) { seenQ.add(key); searches.push(it); }
    }
    if ((it.action === 'doc' || it.action === 'courtcopy') && it.tid && it.title) {
      if (!seenT.has(it.tid) && docs.length < 6) { seenT.add(it.tid); docs.push(it); }
    }
  });

  if (!searches.length && !docs.length) {
    return <Empty>Search by case name, section, topic or citation to get started.</Empty>;
  }

  const searchLink = (it) => {
    const p = new URLSearchParams({ q: it.query_text });
    if (it.court && it.court !== 'all') p.set('court', it.court);
    return `/citations?${p.toString()}`;
  };

  return (
    <div className="cite-recent">
      {searches.length > 0 && (
        <section className="mb-4">
          <h2 className="ec-overline mb-2"><FontAwesomeIcon icon={faClockRotateLeft} /> Your recent searches</h2>
          <div className="d-flex flex-wrap gap-2">
            {searches.map((it) => (
              <Link key={it.id} to={searchLink(it)} className="ec-pill cite-recent-pill">
                <FontAwesomeIcon icon={faMagnifyingGlass} /> {it.query_text}
                {COURT_LABEL[it.court] ? <span className="ec-muted"> · {COURT_LABEL[it.court]}</span> : null}
              </Link>
            ))}
          </div>
        </section>
      )}
      {docs.length > 0 && (
        <section>
          <h2 className="ec-overline mb-2">Judgments you opened</h2>
          {docs.map((it) => (
            <JudgmentRow key={it.id} LinkComponent={Link} to={`/citations/doc/${it.tid}`}
              title={it.title} snippet={`Opened ${fmtTs(it.ts)}`} />
          ))}
        </section>
      )}
      <p className="small ec-muted mb-0">Opening these again is free.</p>
    </div>
  );
}